import styles from './StatusDot.module.css';

interface StatusDotProps {
  tone: 'enabled' | 'disabled' | 'warning' | 'neutral';
}

export function StatusDot({ tone }: StatusDotProps) {
  return (
    <span
      className={`${styles.dot} ${styles[tone]}`}
      data-testid="status-dot"
      data-tone={tone}
      aria-hidden="true"
    />
  );
}
